import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  topUpHistoryContainer: {
    paddingBottom: theme.spacing(22.5),
  },
  topUpHistoryTitleContainer: {
    margin: theme.spacing(17.25, -9),
    padding: theme.spacing(14.5, 24),
  },
  topUpHistoryTitle: {
    fontSize: theme.spacing(11.5),
    lineHeight: '34px',
    fontWeight: 'bold',
  },
  topUpHistoryStatusesFilter: {
    paddingBottom: theme.spacing(17.5),
  },
}));
